{
  "wares": [
    { "id": "ferrite", "name": "Ferrite", "basePrice": 120, "rarity": "common", "tint": "#8C7A6B" },
    { "id": "silicates", "name": "Silicates", "basePrice": 90, "rarity": "common", "tint": "#B8AD95" },
    { "id": "ice", "name": "Ice", "basePrice": 180, "rarity": "uncommon", "tint": "#CFE3EE" },
    { "id": "titanium", "name": "Titanium", "basePrice": 420, "rarity": "uncommon", "tint": "#9FA8B3" },
    { "id": "platinum", "name": "Platinum-group", "basePrice": 2200, "rarity": "rare", "tint": "#D8D2C4" },
    {
      "id": "tetherstone",
      "name": "Tetherstone",
      "unidentifiedName": "Unidentified crystalline",
      "basePrice": 11000,
      "rarity": "veryRare",
      "tint": "#4B4F8F"
    },
    { "id": "refractory_ore", "name": "Refractory ore", "basePrice": 3500, "rarity": "rare", "tint": "#5E6470" }
  ],
  "components": [
    { "type": "reactor", "name": "Reactor", "baseValue": 14000, "massT": [3, 6], "anchors": [3, 4], "hazard": "coolant", "propAsset": "prop.component.reactor" },
    { "type": "radiator", "name": "Radiator", "baseValue": 2000, "massT": [0.5, 2], "anchors": [2, 3], "propAsset": "prop.component.radiator" },
    { "type": "weapon", "name": "Weapon", "baseValue": 5500, "massT": [1, 3], "anchors": [2, 3], "propAsset": "prop.component.weapon" },
    { "type": "shieldGen", "name": "Shield Generator", "baseValue": 7000, "massT": [1.5, 4], "anchors": [2, 4], "propAsset": "prop.component.shield_gen" },
    { "type": "thruster", "name": "Thruster", "baseValue": 3500, "massT": [1, 3], "anchors": [2, 3], "propAsset": "prop.component.thruster" },
    { "type": "cargoPod", "name": "Cargo Pod", "baseValue": 0, "massT": [1.5, 2.5], "anchors": [1, 1], "propAsset": "prop.component.cargo_pod" },
    { "type": "dataCore", "name": "Data Core", "baseValue": 10000, "massT": [0.5, 0.5], "anchors": [2, 2], "propAsset": "prop.component.data_core" }
  ],
  "market": {
    "buyMarkup": 1.15,
    "standingSwing": 0.05,
    "saturation": { "k": 1.1, "halfLifeSeconds": 1200 },
    "drift": { "maxFraction": 0.08, "periodSeconds": [1200, 5400] }
  }
}
